export default __webpack_public_path__ + "static/media/announcement_4@3x.11ae2a77.png";